// Necessary to build the front end styles.
import './style.scss';

import './blocks/query-taxonomy-filter/view';
import './blocks/query-post-date-filter/view';
import './blocks/query-filter-container/view';
import './blocks/tab-layout/view';
import './blocks/formats/tooltip/tooltip-view';

console.log(`[mbm-gutenblocks] front.js loaded`)
